import SecuredCardWelcomeBack from "./SecuredCardWelcomeBack";
export default SecuredCardWelcomeBack;
